import React, { Component } from "react";
import "../styles/Gallery.css";
import Image1 from "./Images/image1.jpg";
import Image2 from "./Images/image2.jpg";
import Image3_cropped from "./Images/image3_cropped.jpg";
import Image4 from "./Images/image4.jpg";
import Image5 from "./Images/image5.jpg";
import Image6 from "./Images/image6.jpg";
import Image7 from "./Images/image7.jpg";
import Image8 from "./Images/image8.jpg";
import Image9 from "./Images/image9.jpg";
import Image10 from "./Images/image10.jpg";
import Image11 from "./Images/image11.jpg";
import Image12 from "./Images/image12.jpg";
import Image13 from "./Images/image13.jpg";
import omanyala from "./Images/omanyala.jpg";
import gyminterior from "./Images/gym interior.jpg";
// import Training from "./Images/training.jpg";



export class Gallery extends Component {
  render() {
    return (
      <div>
        <div className="gallery">
          <div className="item-div">
            <img src={Image1} alt="Empty" />
            <div className="middle">
              <div className="text">Hiking at Elephant Hill Aberdare</div>
            </div>
          </div>
          <div className="item-div">
            <img src={Image2} alt="Empty" />
            <div className="middle">
              <div className="text">Nachu Caves </div>
            </div>
          </div>
          <div className="item-div">
            <img src={Image3_cropped} alt="Empty" />
            <div className="middle">
              <div className="text"> Martial Art Team</div>
            </div>
          </div>
          <div className="item-div">
            <img src={Image4} alt="Empty" />
            <div className="middle">
              <div className="text">Nachu Caves</div>
            </div>
          </div>
          <div className="item-div">
            <img src={Image5} alt="Empty" />
            <div className="middle">
              <div className="text">Nabongo Cultural Centre</div>
            </div>
          </div>
          <div className="item-div">
            <img src={Image6} alt="Empty" />
            <div className="middle">
              <div className="text">Kenya National Assembly Team </div>
            </div>
          </div>
          <div className="item-div">
            <img src={Image7} alt="Empty" />
            <div className="middle">
              <div className="text">Deguna High Rope Course </div>
            </div>
          </div>
          <div className="item-div">
            <img src={Image8} alt="Empty" />
            <div className="middle">
              <div className="text">Longonot </div>
            </div>
          </div>
          <div className="item-div">
            <img src={Image9} alt="Empty" />
            <div className="middle">
              <div className="text">Wazito Fitness team</div>
            </div>
          </div><div className="item-div">
            <img src={Image10} alt="Empty" />
            <div className="middle">
              <div className="text">Forteenth Falls Hiking </div>
            </div>
          </div><div className="item-div">
            <img src={Image11} alt="Empty" />
            <div className="middle">
              <div className="text">Ololosokwan </div>
            </div>
          </div><div className="item-div">
            <img src={Image12} alt="Empty" />
            <div className="middle">
              <div className="text">Marshly</div>
            </div>
          </div>
          <div className="item-div">
            <img src={Image13} alt="Empty" />
            <div className="middle">
              <div className="text">Jayson </div>
            </div>
          </div>
          <div className="item-div">
            <img src={omanyala} alt="Empty" />
            <div className="middle">
              <div className="text">Omanyala </div>
            </div>
          </div>
          <div className="item-div">
            <img src={gyminterior} alt="Empty" />
            <div className="middle">
              <div className="text">gym </div>
            </div>
          </div>


        </div>
      </div>
    );
  }
}

export default Gallery;
